import React from "react";
import WebPageTopics from "../../topics/WebPageTopics";


function ChapterWiseWeightageBioTopics() {
  return (
    <>

         <WebPageTopics subject="biology" type="chapterwiseweightage" />

    </>
  );
}

export default ChapterWiseWeightageBioTopics;